import React from 'react'

import { faUserFriends } from '@fortawesome/pro-regular-svg-icons'
import { faFerrisWheel, faMapMarkerAlt, faVideo } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ProfileSecondary from '@scoir/brand-icons/dist/ProfileSecondary'
import cn from 'classnames'
import { get } from 'lodash'

import CollegeVisit from '.'
import { isShortDuration } from '../durationHelper'
import requiredPropTypes from './requiredPropTypes'

export default function WeekView(props) {
  const isMultiEvent = get(props.event, 'Type') === 'multi'
  const isCollegeFair = get(props.event, 'CollegeFair', false)
  const isVirtual = get(props.event, 'Virtual', false)
  return (
    <CollegeVisit
      {...props}
      className={cn('week', {
        'short-duration': isShortDuration(props.event),
      })}
      summary={
        <React.Fragment>
          <span className="student-count pull-right">
            <ProfileSecondary
              size="xs"
              className="profile-icon"
            />
            {props.event.NumAttendees}
          </span>
          <>
            <div>
              <strong>
                {isMultiEvent ? (
                  isCollegeFair ? (
                    <FontAwesomeIcon icon={faFerrisWheel} />
                  ) : (
                    <span>
                      <FontAwesomeIcon
                        icon={faUserFriends}
                        className="slot-icon"
                      />
                    </span>
                  )
                ) : (
                  <span>
                    {isVirtual ? <FontAwesomeIcon icon={faVideo} /> : <FontAwesomeIcon icon={faMapMarkerAlt} />}{' '}
                  </span>
                )}
                <span>High School Visit </span>
              </strong>
            </div>
            <div className="high-school-name">
              <span>{props.event.HighSchoolName}</span>
            </div>
          </>
        </React.Fragment>
      }
    />
  )
}
WeekView.propTypes = requiredPropTypes
